export default __webpack_public_path__ + "static/media/pointer-left.4100a56e.svg";